import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './Layout.html';
import moment from 'moment';
import UserService from '../../shared/userService/UserService';
import UserModel from '../../shared/userService/Model/UserModel';
import TokenService from '../../Services/TokenService';
import { Toaster } from '../../Services/toast';
import LoginService from '../Login/LoginService';
import UserRoleService from '../../shared/userService/UserRoleService';
import PermissionManagementService from '../UserManagement/PermissionManagement/PermissionManagementService';
import { KEY_TO_SCREEN } from '../UserManagement/PermissionManagement/PermissionsKeys';
import GlobalLogoutService from '../../Services/GlobalLogoutService';
import {
    ensureSsoRuntimeConfigLoaded,
    getSsoLogoutUrl,
    redirectToSsoLogin,
} from '@/Services/ssoNavigation';
import { RequestsOptionsModel } from '../Dashboard/RequestsOptionsModel ';
import DashboardService from '../Dashboard/DashboardService';
import Dashboard from '../Dashboard/Dashboard';

@WithRender
@Component({
    diProvide: [
        DashboardService,
        UserService,
        LoginService,
        UserRoleService,
        PermissionManagementService,
        GlobalLogoutService,
    ],
})
export default class Layout extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(DashboardService) public dashboardService!: DashboardService;
    @Inject(TokenService) public tokenService!: TokenService;
    @Inject(GlobalLogoutService) public globalLogoutService!: GlobalLogoutService;
    @Inject(LoginService) public logInService!: LoginService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(PermissionManagementService) public permissionManagementService!: PermissionManagementService;
    public userName: string = '';
    public password: string = '';
    public isDropdownShow: boolean = false;
    public isReportDropdownShow: boolean = false;
    public isShortcodeConnectingShow: boolean = false;
    public isRolesManagement: boolean = false;
    public isSuggestionsAndFeedback: boolean = false;
    public isSystemConfiguration: boolean = false;
    public isFinance: boolean = false;
    public layoutSup: boolean = false;
    public logOutDialog: boolean = false;
    public loginDialog: boolean = false;
    public showPassword: boolean = false;
    public otpForm: boolean = false;
    public logInForm: boolean = true;
    public collapsed: boolean = false;
    public sidebarCollapsed: boolean = false;
    public data: string = '';
    public otpExpiresAt: string = '';
    public otp: string = '';
    public userRole: any;
    public countDown: number = 0;
    public themeCompany: any = 'Default';
    public logoLayoutSrc: any = 'JabberLogo';
    public errorUserCertificate: boolean = false;
    public requestsOptions: RequestsOptionsModel = {} as RequestsOptionsModel;

    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            TenantId: '',
            ProviderId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };

    private get isSenderTemplateEnabled(): boolean {
        return !!(window.$config && window.$config.EnableSenderTemplate === true);
    }

    // The Template Filter Check page calls the external T2.TemplateChecker service. It has its OWN flag so it
    // is switched on and off independently of EnableSenderTemplate, which governs the message-template feature.
    private get isTemplateFilterCheckEnabled(): boolean {
        return !!(window.$config && window.$config.EnableTemplateFilterCheck === true);
    }

    public get menuForCurrentRole() {
        const role = this.GetUserRole;

        // Super Admin
        if (role === 9) {
            return this.withVisibleMenuParents([
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SenderRequestDashboard',
                            text: this.$t('shared.dashboard'),
                            route: '/Dashboard',
                            show: true
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        },
                        {
                            key: 'SenderComplaintList',
                            text: this.$t('shared.senderComplaintsList'),
                            route: '/SenderComplaints',
                            show: true
                        },
                        {
                            key: 'SenderConnectivity',
                            text: this.$t('shared.senderConnectivity'),
                            route: '/SenderConectivitySupport',
                            show: true
                        },
                        {
                            key: 'ShortCodeList',
                            text: this.$t('shortPage.shortCodeList'),
                            route: '/Shorts',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ContractRequestDashboard',
                            text: this.$t('shared.connectingRequestDashboard'),
                            route: '/ConnectingRequestDashboard',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'MessageTemplateDashboard',
                            text: this.$t('shared.MessageTemplateDashboard'),
                            route: '/MessageTemplateDashboard',
                            show: this.isSenderTemplateEnabled
                        }
                    ]
                },
                {
                    key: 'RolesManagement',
                    text: this.$t('shared.rolesManagement'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'Providers',
                            text: this.$t('shared.providers'),
                            route: '/Providers',
                            show: true
                        },
                        {
                            key: 'UserManagement',
                            text: this.$t('shared.userManagement'),
                            route: '/UserManagement',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SystemConfig',
                    text: this.$t('shared.systemConfiguration'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'Scams',
                            text: this.$t('shared.ScamManagement'),
                            route: '/Scams',
                            show: true
                        },
                        {
                            key: 'AttachmentCategory',
                            text: this.$t('shared.AttachmentCategory'),
                            route: '/AttachmentCategory',
                            show: true
                        },
                        {
                            key: 'RejectionReason',
                            text: this.$t('shared.RejectionReason'),
                            route: '/RejectionReason',
                            show: true
                        },
                        {
                            key: 'CITCKeywords',
                            text: this.$t('shared.CITCKeywords'),
                            route: '/CITCKeywords',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'CreditLimitTransaction',
                            text: this.$t('shared.CreditLimitTransaction'),
                            route: '/CreditLimitTransaction',
                            show: true
                        },
                        {
                            key: 'ProvidersFinance',
                            text: this.$t('shared.providersFinance'),
                            route: '/ProvidersFinance',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Reports',
                    text: this.$t('shared.Reports'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ReportsOverview',
                            text: this.$t('shared.ReportsOverview'),
                            route: '/Report',
                            show: true
                        },
                        {
                            key: 'ConnectivityActivationReport',
                            text: this.$t('shared.connectivityActivationReport'),
                            route: '/ConnectivityActivationReport',
                            show: true
                        },
                        {
                            key: 'EmployeeStatistics',
                            text: this.$t('shared.employeeStatistics'),
                            route: '/EmployeeStatistics',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SuggestionFeedback',
                    text: this.$t('shared.suggestionsAndFeedback'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SuggestionsAndSystemEnhancement',
                            text: this.$t('shared.suggestionsAndSystemEnhancement'),
                            route: '/SuggestionsAndSystemEnhancement',
                            show: true
                        },
                        {
                            key: 'RatingResults',
                            text: this.$t('shared.ratingResults'),
                            route: '/RatingResults',
                            show: true
                        }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }

        // Provider Admin
        if (role === 5) {
            return this.withVisibleMenuParents([
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SenderRequestDashboard',
                            text: this.$t('shared.dashboard'),
                            route: '/Dashboard',
                            show: true
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        },
                        {
                            key: 'ExtendDurationRequests',
                            text: this.$t('shared.extendDurationRequests'),
                            route: '/ExtendDurationRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isRenewRequstEnabled)
                        },
                        {
                            key: 'SenderConnectivity',
                            text: this.$t('shared.senderConnectivity'),
                            route: '/SenderConectivitySupport',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ContractRequestDashboard',
                            text: this.$t('shared.connectingRequestDashboard'),
                            route: '/ConnectingRequestDashboard',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'MessageTemplateDashboard',
                            text: this.$t('shared.MessageTemplateDashboard'),
                            route: '/MessageTemplateDashboard',
                            show: this.isSenderTemplateEnabled
                        },
                        {
                            key: 'TemplateRenewalRequests',
                            text: this.$t('shared.templatesRenewalRequests'),
                            route: '/MessageTemplateDashboard/TemplateRenewalRequests',
                            show: this.isSenderTemplateEnabled
                        },
                        {
                            key: 'TemplateFilterCheck',
                            text: this.$t('templateFilterCheck.menu'),
                            route: '/TemplateFilterCheck',
                            show: this.isTemplateFilterCheckEnabled
                        }
                    ]
                },
                {
                    key: 'ShortCodes',
                    text: this.$t('shared.shorts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ShortCodeList',
                            text: this.$t('shortPage.shortCodeList'),
                            route: '/Shorts',
                            show: true
                        },
                        {
                            key: 'ShortcodeConnectingRequest',
                            text: this.$t('bulkshortPage.shortCodeConnectivityRequest'),
                            route: '/ShortcodeConnectingRequest',
                            show: true
                        }
                    ]
                },
                {
                    key: 'RolesManagement',
                    text: this.$t('shared.rolesManagement'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'UserManagement',
                            text: this.$t('shared.userManagement'),
                            route: '/UserManagement',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'Invoices',
                            text: this.$t('shared.Invoices'),
                            route: '/Invoices',
                            show: true
                        },
                        {
                            key: 'BalanceInvoice',
                            text: this.$t('shared.BalanceInvoice'),
                            route: '/BalanceInvoice',
                            show: true
                        },
                        {
                            key: 'CreditLimitTransaction',
                            text: this.$t('shared.CreditLimitTransaction'),
                            route: '/CreditLimitTransaction',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SuggestionFeedback',
                    text: this.$t('shared.suggestionsAndFeedback'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SuggestionsAndSystemEnhancement',
                            text: this.$t('shared.suggestionsAndSystemEnhancement'),
                            route: '/AddSuggestionsAndSystemEnhancement',
                            show: true
                        }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }

        // Provider User
        if (role === 2) {
            return this.withVisibleMenuParents([
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SenderRequestDashboard',
                            text: this.$t('shared.dashboard'),
                            route: '/Dashboard',
                            show: true
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        },
                        {
                            key: 'ExtendDurationRequests',
                            text: this.$t('shared.extendDurationRequests'),
                            route: '/ExtendDurationRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isRenewRequstEnabled)
                        },
                        {
                            key: 'SenderConnectivity',
                            text: this.$t('shared.senderConnectivity'),
                            route: '/SenderConectivitySupport',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ContractRequestDashboard',
                            text: this.$t('shared.connectingRequestDashboard'),
                            route: '/ConnectingRequestDashboard',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'MessageTemplateDashboard',
                            text: this.$t('shared.MessageTemplateDashboard'),
                            route: '/MessageTemplateDashboard',
                            show: this.isSenderTemplateEnabled
                        },
                        {
                            key: 'TemplateRenewalRequests',
                            text: this.$t('shared.templatesRenewalRequests'),
                            route: '/MessageTemplateDashboard/TemplateRenewalRequests',
                            show: this.isSenderTemplateEnabled
                        },
                        {
                            key: 'TemplateFilterCheck',
                            text: this.$t('templateFilterCheck.menu'),
                            route: '/TemplateFilterCheck',
                            show: this.isTemplateFilterCheckEnabled
                        }
                    ]
                },
                {
                    key: 'ShortCodes',
                    text: this.$t('shared.shorts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ShortCodeList',
                            text: this.$t('shortPage.shortCodeList'),
                            route: '/Shorts',
                            show: true
                        },
                        {
                            key: 'ShortcodeConnectingRequest',
                            text: this.$t('bulkshortPage.shortCodeConnectivityRequest'),
                            route: '/ShortcodeConnectingRequest',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'Invoices',
                            text: this.$t('shared.Invoices'),
                            route: '/Invoices',
                            show: true
                        },
                        {
                            key: 'BalanceInvoice',
                            text: this.$t('shared.BalanceInvoice'),
                            route: '/BalanceInvoice',
                            show: true
                        },
                        {
                            key: 'CreditLimitTransaction',
                            text: this.$t('shared.CreditLimitTransaction'),
                            route: '/CreditLimitTransaction',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SuggestionFeedback',
                    text: this.$t('shared.suggestionsAndFeedback'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SuggestionsAndSystemEnhancement',
                            text: this.$t('shared.suggestionsAndSystemEnhancement'),
                            route: '/AddSuggestionsAndSystemEnhancement',
                            show: true
                        }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }

        // Platform Admin
        if (role === 1) {
            return this.withVisibleMenuParents([
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SenderRequestDashboard',
                            text: this.$t('shared.dashboard'),
                            route: '/Dashboard',
                            show: true
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        },
                        {
                            key: 'SenderComplaints',
                            text: this.$t('shared.senderComplaintsList'),
                            route: '/SenderComplaints',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ContractRequestDashboard',
                            text: this.$t('shared.connectingRequestDashboard'),
                            route: '/ConnectingRequestDashboard',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'MessageTemplateDashboard',
                            text: this.$t('shared.MessageTemplateDashboard'),
                            route: '/MessageTemplateDashboard',
                            show: this.isSenderTemplateEnabled
                        }
                    ]
                },
                {
                    key: 'RolesManagement',
                    text: this.$t('shared.rolesManagement'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'Providers',
                            text: this.$t('shared.providers'),
                            route: '/Providers',
                            show: true
                        },
                        {
                            key: 'UserManagement',
                            text: this.$t('shared.userManagement'),
                            route: '/UserManagement',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SystemConfig',
                    text: this.$t('shared.systemConfiguration'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'Scams',
                            text: this.$t('shared.ScamManagement'),
                            route: '/Scams',
                            show: true
                        },
                        {
                            key: 'AttachmentCategory',
                            text: this.$t('shared.AttachmentCategory'),
                            route: '/AttachmentCategory',
                            show: true
                        },
                        {
                            key: 'RejectionReason',
                            text: this.$t('shared.RejectionReason'),
                            route: '/RejectionReason',
                            show: true
                        },
                        {
                            key: 'CITCKeywords',
                            text: this.$t('shared.CITCKeywords'),
                            route: '/CITCKeywords',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'CreditLimitTransaction',
                            text: this.$t('shared.CreditLimitTransaction'),
                            route: '/CreditLimitTransaction',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Reports',
                    text: this.$t('shared.Reports'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ReportsOverview',
                            text: this.$t('shared.ReportsOverview'),
                            route: '/Report',
                            show: true
                        },
                        {
                            key: 'ConnectivityActivationReport',
                            text: this.$t('shared.connectivityActivationReport'),
                            route: '/ConnectivityActivationReport',
                            show: true
                        }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }


        // CITC Admin
        if (role === 3) {
            return this.withVisibleMenuParents([
                { key: 'MonitorDashboard', text: this.$t('userManagementPage.monitorDashboard'), route: '/MonitorDashboard', show: true },
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'SenderRequestDashboard', text: this.$t('shared.dashboard'), route: '/Dashboard', show: true },
                        { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                        { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled }
                    ]
                },
                {
                    key: 'RolesManagement',
                    text: this.$t('shared.rolesManagement'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                {
                    key: 'SystemConfig',
                    text: this.$t('shared.systemConfiguration'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'Scams', text: this.$t('shared.ScamManagement'), route: '/Scams', show: true },
                        { key: 'AttachmentCategory', text: this.$t('shared.AttachmentCategory'), route: '/AttachmentCategory', show: true },
                        { key: 'CITCKeywords', text: this.$t('shared.CITCKeywords'), route: '/CITCKeywords', show: true }
                    ]
                },
                {
                    key: 'Reports',
                    text: this.$t('shared.Reports'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                        { key: 'ConnectivityActivationReport', text: this.$t('shared.connectivityActivationReport'), route: '/ConnectivityActivationReport', show: true }
                    ]
                },
                {
                    key: 'SuggestionsFeedback',
                    text: this.$t('shared.suggestionsAndFeedback'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/SuggestionsAndSystemEnhancement', show: true },
                        { key: 'RatingResults', text: this.$t('shared.ratingResults'), route: '/RatingResults', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }


        // CITC User
        if (role === 4) {
            const base = [
                { key: 'MonitorDashboard', text: this.$t('userManagementPage.monitorDashboard'), route: '/MonitorDashboard', show: true },
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'SenderRequestDashboard', text: this.$t('shared.dashboard'), route: '/Dashboard', show: true },
                        { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                        { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled }
                    ]
                },
                {
                    key: 'RolesManagement',
                    text: this.$t('shared.rolesManagement'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                {
                    key: 'SystemConfig',
                    text: this.$t('shared.systemConfiguration'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'Scams', text: this.$t('shared.ScamManagement'), route: '/Scams', show: true },
                        { key: 'AttachmentCategory', text: this.$t('shared.AttachmentCategory'), route: '/AttachmentCategory', show: true },
                        { key: 'CITCKeywords', text: this.$t('shared.CITCKeywords'), route: '/CITCKeywords', show: true }
                    ]
                },
                {
                    key: 'Reports',
                    text: this.$t('shared.Reports'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                        { key: 'ConnectivityActivationReport', text: this.$t('shared.connectivityActivationReport'), route: '/ConnectivityActivationReport', show: true }
                    ]
                },
                {
                    key: 'SuggestionsFeedback',
                    text: this.$t('shared.suggestionsAndFeedback'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/SuggestionsAndSystemEnhancement', show: true },
                        { key: 'RatingResults', text: this.$t('shared.ratingResults'), route: '/RatingResults', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
            return this.withVisibleMenuParents(this.applyPermissions(base));
        }



        // Support
        if (role === 6) {
            return this.withVisibleMenuParents([
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SenderConnectivity',
                            text: this.$t('shared.SenderConnectivitySupport'),
                            route: '/SenderConectivitySupport',
                            show: true
                        },
                        {
                            key: 'SenderRequestSupport',
                            text: this.$t('shared.senderRequestSupport'),
                            route: '/SenderRequestSupport',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'PreApprovedTemplates',
                            text: this.$t('shared.preApprovedTemplates'),
                            route: '/PreApprovedTemplates',
                            show: this.isSenderTemplateEnabled
                        },
                        {
                            key: 'RegulationsManagement',
                            text: this.$t('shared.regulationsMenu'),
                            route: '/Regulations',
                            show: this.isSenderTemplateEnabled
                        },
                        {
                            key: 'TemplateFilterCheck',
                            text: this.$t('templateFilterCheck.menu'),
                            route: '/TemplateFilterCheck',
                            show: this.isTemplateFilterCheckEnabled
                        }
                    ]
                },
                {
                    key: 'Providers',
                    text: this.$t('shared.providers'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ProvidersList',
                            text: this.$t('providerPage.providersList'),
                            route: '/ProviderSupport',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SupportPaymentTransaction',
                            text: this.$t('shared.SupportPaymentTransaction'),
                            route: '/SupportPaymentTransaction',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SuggestionsFeedback',
                    text: this.$t('shared.suggestionsAndFeedback'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SuggestionsAndSystemEnhancement',
                            text: this.$t('shared.suggestionsAndSystemEnhancement'),
                            route: '/SuggestionsAndSystemEnhancement',
                            show: true
                        },
                        {
                            key: 'RatingResults',
                            text: this.$t('shared.ratingResults'),
                            route: '/RatingResults',
                            show: true
                        }
                    ]
                },
                {
                    key: 'SLA',
                    text: this.$t('shared.sla'),
                    route: '/SLA',
                    show: true
                }
            ]);
        }

        // Finance
        if (role === 8) {
            return this.withVisibleMenuParents([
                {
                    key: 'Invoices',
                    text: this.$t('shared.Invoices'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'InvoicesList', text: this.$t('shared.invoicesList'), route: '/Invoices', show: true },
                        { key: 'BalanceInvoice', text: this.$t('shared.BalanceInvoice'), route: '/BalanceInvoice', show: true }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }

        // Monitor
        if (role === 10) {
            return [
                { key: 'MonitorDashboard', text: this.$t('userManagementPage.monitorDashboard'), route: '/MonitorDashboard', show: true }
            ];
        }

        // Managing Requests
        if (role === 15) {
            return this.withVisibleMenuParents([
                {
                    key: 'Senders',
                    text: this.$t('shared.senders'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'SenderRequestDashboard',
                            text: this.$t('shared.dashboard'),
                            route: '/Dashboard',
                            show: true
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        }
                    ]
                },
                {
                    key: 'Contracts',
                    text: this.$t('shared.contracts'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ConnectingRequestDashboard',
                            text: this.$t('shared.connectingRequestDashboard'),
                            route: '/ConnectingRequestDashboard',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Templates',
                    text: this.$t('shared.templates'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'MessageTemplateDashboard',
                            text: this.$t('shared.MessageTemplateDashboard'),
                            route: '/MessageTemplateDashboard',
                            show: this.isSenderTemplateEnabled
                        }
                    ]
                },
                {
                    key: 'Finance',
                    text: this.$t('Finance'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'CreditLimitTransaction',
                            text: this.$t('shared.CreditLimitTransaction'),
                            route: '/CreditLimitTransaction',
                            show: true
                        }
                    ]
                },
                {
                    key: 'Reports',
                    text: this.$t('shared.Reports'),
                    isDropdown: true,
                    show: true,
                    children: [
                        {
                            key: 'ReportsOverview',
                            text: this.$t('shared.ReportsOverview'),
                            route: '/Report',
                            show: true
                        }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ]);
        }

        // Fraud Management
        if (role === 16) {
            return [
                { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Default
        return [
            { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
        ];

    }

    public get sidebarNavItems() {
        return this.menuForCurrentRole.filter((item) => item.key !== 'SLA' && item.show !== false);
    }

    public get showSidebarSlaLink(): boolean {
        return this.menuForCurrentRole.some((item) => item.key === 'SLA' && item.show !== false);
    }

    public openDropdownKeys: string[] = [];

    public openDropdown(key: string) {
        if (this.sidebarCollapsed) {
            this.sidebarCollapsed = false;
        }
        const index = this.openDropdownKeys.indexOf(key);
        if (index >= 0) {
            this.openDropdownKeys = this.openDropdownKeys.filter((k) => k !== key);
        } else {
            this.openDropdownKeys = this.openDropdownKeys.concat([key]);
        }
    }
    public isDropdownOpen(key: string) {
        return this.openDropdownKeys.indexOf(key) >= 0;
    }
    public closeAllDropdowns() {
        this.openDropdownKeys = [];
    }

    public isDropdownParentActive(item: any): boolean {
        if (!item.children) return false;
        return item.children.some((child: { route: string; }) => this.$route.path === child.route);
    }

    public onParentNavClick(item: any, event: Event) {
        if (this.sidebarCollapsed) {
            event.preventDefault();
            this.sidebarCollapsed = false;
            if (!this.isDropdownOpen(item.key)) {
                this.openDropdownKeys = this.openDropdownKeys.concat([item.key]);
            }
            this.closeMobileMenu();
            return;
        }
        this.closeMobileMenu();
    }

    public onParentToggleClick(item: any) {
        this.openDropdown(item.key);
        this.closeMobileMenu();
    }

    public getMenuIcon(key: string): string {
        const icons: { [name: string]: string } = {
            Senders: 'fas fa-paper-plane',
            SenderRequestDashboard: 'fas fa-mail-bulk',
            SenderComplaintList: 'fas fa-exclamation-triangle',
            SenderComplaints: 'fas fa-exclamation-triangle',
            SenderConnectivity: 'fas fa-network-wired',
            ShortCodeList: 'fas fa-hashtag',
            ShortCodes: 'fas fa-hashtag',
            ShortcodeConnectingRequest: 'fas fa-plug',
            UpdateRequests: 'fas fa-edit',
            ExtendDurationRequests: 'fas fa-external-link-alt',
            Contracts: 'fas fa-file-contract',
            ContractRequestDashboard: 'fas fa-file-signature',
            ConnectingRequestDashboard: 'fas fa-file-signature',
            Templates: 'fas fa-envelope-open-text',
            MessageTemplateDashboard: 'fas fa-file-alt',
            TemplateRenewalRequests: 'fas fa-redo',
            TemplateFilterCheck: 'fas fa-vial',
            PreApprovedTemplates: 'fas fa-check-double',
            RolesManagement: 'fas fa-users-cog',
            Providers: 'fas fa-building',
            ProvidersList: 'fas fa-building',
            UserManagement: 'fas fa-user-friends',
            SystemConfig: 'fas fa-cogs',
            Scams: 'fas fa-shield-alt',
            AttachmentCategory: 'fas fa-paperclip',
            RejectionReason: 'fas fa-ban',
            CITCKeywords: 'fas fa-key',
            RegulationsManagement: 'fas fa-balance-scale',
            Finance: 'fas fa-coins',
            Invoices: 'fas fa-file-invoice-dollar',
            InvoicesList: 'fas fa-file-invoice-dollar',
            BalanceInvoice: 'fas fa-wallet',
            CreditLimitTransaction: 'fas fa-credit-card',
            ProvidersFinance: 'fas fa-university',
            SupportPaymentTransaction: 'fas fa-money-check-alt',
            Reports: 'fas fa-chart-bar',
            ReportsOverview: 'fas fa-chart-pie',
            ConnectivityActivationReport: 'fas fa-signal',
            EmployeeStatistics: 'fas fa-chart-line',
            SuggestionFeedback: 'fas fa-comment-dots',
            SuggestionsFeedback: 'fas fa-comment-dots',
            SuggestionsAndSystemEnhancement: 'fas fa-lightbulb',
            RatingResults: 'fas fa-star',
            MonitorDashboard: 'fas fa-chart-line',
            SenderRequestSupport: 'fas fa-headset',
            MyProfile: 'fas fa-user-circle',
            SLA: 'fas fa-clock',
        };
        if (icons[key]) {
            return icons[key];
        }
        return 'fas fa-circle';
    }




    public created() {
        if (process.env.VUE_APP_TITLE !== undefined && process.env.VUE_APP_LogoLayoutSrc !== undefined) {
            this.themeCompany = process.env.VUE_APP_TITLE.toString();
            this.logoLayoutSrc = process.env.VUE_APP_LogoLayoutSrc.toString();
        } else {
            this.themeCompany = 'Default';
            this.logoLayoutSrc = 'JabberLogo';
        }
        this.countDownTimer();
    }

    public async mounted() {
        this.user = await this.userService.getUser();
        await this.getRequestsOptions();

        await this.refreshAllowedScreens();
        this.ensureActiveParentOpen();
        this.$router.afterEach(async () => {
            await this.refreshAllowedScreens();
        });
        window.addEventListener('resize', this.onWindowResize);
        this.onWindowResize();
    }

    public beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
    }

    public onWindowResize() {
        if (typeof window === 'undefined') {
            return;
        }

        if (window.innerWidth >= 992) {
            this.collapsed = false;
            return;
        }

        this.sidebarCollapsed = false;
    }
    public async getRequestsOptions() {
        try {
            const response = await this.dashboardService.getRequestsOptions();
            if (response && response.result) {
                this.requestsOptions.isRenewRequstEnabled = response.result.isRenewRequstEnabled;
                this.requestsOptions.isUpdateRequstDataEnabled = response.result.isUpdateRequstDataEnabled;
                this.requestsOptions = {
                    ...this.requestsOptions,
                    isRenewRequstEnabled: response.result.isRenewRequstEnabled,
                    isUpdateRequstDataEnabled: response.result.isUpdateRequstDataEnabled,
                };
                let stored: any = {};
                try {
                    const raw = sessionStorage.getItem('requestsOptions');
                    if (raw) {
                        stored = JSON.parse(raw) || {};
                    }
                } catch (parseError) {
                    stored = {};
                }
                sessionStorage.setItem('requestsOptions', JSON.stringify({
                    ...stored,
                    isUpdateRequstDataEnabled: response.result.isUpdateRequstDataEnabled,
                }));
            }
        } catch (error) {
            console.error("Error fetching options", error);
            this.requestsOptions.isRenewRequstEnabled = false;
            this.requestsOptions.isUpdateRequstDataEnabled = false;
            sessionStorage.setItem('requestsOptions', JSON.stringify({
                isUpdateRequstDataEnabled: false,
            }));
        }
    }
    public collapse() {
        this.collapsed = !this.collapsed;
    }

    public toggleDesktopSidebar() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        this.notifyMainAreaResize();
    }

    private notifyMainAreaResize() {
        if (typeof window === 'undefined') {
            return;
        }

        const fireResize = () => {
            window.dispatchEvent(new Event('resize'));
        };

        this.$nextTick(() => {
            fireResize();
            window.setTimeout(fireResize, 220);
        });
    }

    public closeMobileMenu() {
        this.collapsed = false;
    }

    public ensureActiveParentOpen() {
        const menu = this.menuForCurrentRole;
        if (!menu || !menu.length) {
            return;
        }

        for (const item of menu) {
            if (!item || !item.isDropdown || !item.children || !item.children.length) {
                continue;
            }

            const hasActiveChild = item.children.some((child: { route: string; show?: boolean }) => {
                return child.show !== false && this.$route.path === child.route;
            });

            if (hasActiveChild && this.openDropdownKeys.indexOf(item.key) < 0) {
                this.openDropdownKeys = this.openDropdownKeys.concat([item.key]);
            }
        }
    }

    @Watch('$route')
    public onRouteChange() {
        this.collapsed = false;
        this.ensureActiveParentOpen();
    }

    public onChildInit(value: boolean) {
        this.layoutSup = value;
    }

    public get currentPageTitle(): string {
        const path = this.$route.path;
        const menu = this.menuForCurrentRole;
        if (!menu || !menu.length) {
            return '';
        }

        let matchedTitle = '';
        for (let i = 0; i < menu.length; i++) {
            const item = menu[i];
            if (!item || item.show === false) {
                continue;
            }

            if (item.children && item.children.length) {
                for (let j = 0; j < item.children.length; j++) {
                    const child = item.children[j];
                    if (child && child.show !== false && child.route && path === child.route) {
                        return String(child.text);
                    }
                }
            }

            if (item.route && path === item.route) {
                matchedTitle = String(item.text);
            }
        }

        return matchedTitle;
    }

    public get currentYear() {
        return moment().year();
    }

    public showLogOutDialog() {
        this.logOutDialog = true;
    }

    public hideLogOutDialog() {
        this.logOutDialog = false;
    }

    public async logOut() {
        this.logOutDialog = false;
        try {
            await ensureSsoRuntimeConfigLoaded();
            window.location.href = getSsoLogoutUrl();
        } catch (error) {
            console.error('error:', error);
            await this.globalLogoutService.clearLocalSession();
            await redirectToSsoLogin();
        }
    }

    public countDownTimer() {
        const currentDate = moment().format('lll');
        if (!moment(currentDate).isAfter(localStorage.expiresIn)) {
            setTimeout(() => {
                this.countDownTimer();
                localStorage.timer -= 1;
                if (localStorage.timer === '900') {
                    Toaster.warning('15 minutes left for your login to expire', this.showLoginDialog);
                }
            }, 1000);
        } else {
            this.logOut();
        }
    }

    public showLoginDialog() {
        this.userName = '';
        this.otp = '';
        this.password = '';
        this.loginDialog = true;
    }

    public hideLoginDialog() {
        this.loginDialog = false;
        this.logInForm = true;
        this.otpForm = false;
    }

    public get GetUserRole() {
        return this.userRoleService.GetUserRole(this.user);
    }

    public get showProviderProfileLink(): boolean {
        const role = this.GetUserRole;
        return role === 5 || role === 2;
    }
    public get isValid(): boolean {
        return (this.userName.trim() !== '' && this.password.trim() !== '');
    }

    public async login() {
        if (this.user.username.toLowerCase() === this.userName.toLowerCase()) {
            const result = await this.logInService.login(this.userName, this.password, "");
            if (result.isSuccess && result.isOTPEnabled) {
                this.data = result.data;
                this.otpExpiresAt = result.expiresAt;
                this.countDown = result.duration;
                this.switchToOtpForm();
                this.countDownTimerOTP();
            } else if (result.isSuccess && !result.isOTPEnabled) {
                await this.tokenService.setToken(result.data);
                const expiresIn = parseInt(result.duration, 0);
                localStorage.timer = expiresIn * 60;
                localStorage.expiresIn = moment().add(expiresIn, 'minutes').format('lll');
                this.userRole = this.GetUserRole;
                if (this.userRole === 8) {
                    window.location.href = '/Providers';
                } else {
                    window.location.href = '/Dashboard';
                }
                this.loginDialog = false;
            } else {
                this.loginDialog = false;
                Toaster.error(result.errorMessage);
            }
        } else {
            this.errorUserCertificate = true;
        }
    }

    public switchToOtpForm() {
        this.logInForm = false;
        this.otpForm = true;
    }

    public countDownTimerOTP() {
        if (this.countDown > 0) {
            setTimeout(() => {
                this.countDown -= 1;
                this.countDownTimerOTP();
            }, 1000);
        }
    }

    public async resendOtp() {
        const result = await this.logInService.resendOTP(this.data);
        if (result.isSuccess) {
            this.data = result.data;
            this.otpExpiresAt = result.expiresAt;
            this.countDown = result.duration;
            this.countDownTimerOTP();
        } else {
            Toaster.error(result.errorMessage);
        }
    }

    public async verfiyOTP() {
        const result = await this.logInService.verfiyOTP(this.data, this.otpExpiresAt, this.otp);
        if (result.isSuccess) {
            await this.tokenService.setToken(result.token);
            const expiresIn = parseInt(result.expiresIn, 0);
            localStorage.timer = expiresIn * 60;
            localStorage.expiresIn = moment().add(expiresIn, 'minutes').format('lll');
            this.loginDialog = false;
            this.logInForm = true;
            this.otpForm = false;
        } else {
            this.loginDialog = false;
            this.logInForm = true;
            this.otpForm = false;
            Toaster.error(result.errorMessage);
        }
    }

    public get isResendValid(): boolean {
        return (this.countDown > 0);
    }

    private allowedScreens: Set<string> | null = null;

    private isScreenAllowedByKey(menuKey: string): boolean {
        const screen = KEY_TO_SCREEN[menuKey];
        if (!screen) return true;
        if (!this.allowedScreens) return true;
        return this.allowedScreens.has(screen);
    }

    private withVisibleMenuParents(menu: any[]): any[] {
        return menu.map(item => {
            if (!Array.isArray(item.children) || !item.children.length) {
                return item;
            }

            const children = item.children.filter((c: any) => c.show !== false);
            const hasRoute = !!item.route;
            const showParent = item.show !== false && (hasRoute || children.length > 0);

            return { ...item, children, show: showParent };
        });
    }

    private applyPermissions(menu: any[]): any[] {
        return menu.map(item => {
            const ownShow = item.show !== false && this.isScreenAllowedByKey(item.key);

            if (Array.isArray(item.children) && item.children.length) {
                const children = item.children
                    .map((c: any) => ({ ...c, show: (c.show !== false) && this.isScreenAllowedByKey(c.key) }))
                    .filter((c: any) => c.show);

                const hasRoute = !!item.route;
                const showParent = hasRoute ? ownShow : (children.length > 0);

                return { ...item, show: showParent, children };
            }

            return { ...item, show: ownShow };
        });
    }

    private async refreshAllowedScreens(): Promise<void> {
        if (this.GetUserRole !== 4) {
            this.allowedScreens = null;
            return;
        }
        const res = await this.permissionManagementService.GetPermissions(this.user.userId);
        const ok = res && (res.isSuccess === true || res.IsSuccess === true);
        if (!ok) return;

        const list = (res.result || res.Result || []) as Array<{ screenKey?: string; ScreenKey?: string; isAllowed?: boolean; IsAllowed?: boolean }>;
        this.allowedScreens = new Set(
            list
                .filter(x => x.isAllowed === true || (x as any).IsAllowed === true)
                .map(x => (x.screenKey || (x as any).ScreenKey) as string)
        );
    }
}
